import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { MyDomain } from "../../App";
import { useAppContext } from "../../AppContext";
import { FaHeart } from "react-icons/fa";
import Rating from "@mui/material/Rating";
import shoppingbag from "../../Images/shoppingbag.png";
import ArrowDown from "../../Images/ArrowDown.png";
import arrowleft from "../../Images/arrowleft.png";
import arrowright from "../../Images/arrowright.png";
import CloseImg from "../../Images/CloseImg.png";
import Lottie from "lottie-react";
import LottifileLoading from "../../LottifileLoading.json";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AllCategoriesCartDialog from "../AllCategoriesComponents/AllCategoriesCartDialog";
import { useHistory } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1024
        ? "90%"
        : window.innerWidth <= 1920
        ? "40%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "50%"
        : "40%",
    margin: "0 auto",
    maxWidth: "none",
    borderRadius: 0,
  },
}));

const BootstrapDialogMobile = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%",
    margin: "0 auto",
    maxWidth: "none",
    borderRadius: 0,
  },
}));

export default function PerfumeBlock({ CatCall }) {
  const {
    AllData,
    WishList,
    setWishList,
    CartAmount,
    setCartAmount,
    setOpenLoginPopOver,
  } = useAppContext();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  const [BuyNotLogin, setBuyNotLogin] = useState(false);
  const [MyOpen, setMyOpen] = useState(false);
  const [MobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [ProductChoosed, setProductChoosed] = useState([]);
  const [ImageChoosed, setImageChoosed] = useState("");
  const [OBJOfProductChoosed, setOBJOfProductChoosed] = useState({});
  const [ProductChoosed2, setProductChoosed2] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [LoadingClickBuyButton, setLoadingClickBuyButton] = useState(false);
  const wrapperRef = useRef();

  const user = JSON.parse(localStorage.getItem("user"));
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const handleDivClick2 = (CategoryName, ProductId) => {
    CreateRecently(ProductId);
    history.push(`/product/${ProductId}`);
  };

  const CreateRecently = (IdOfProduct) => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    const formattedTime = now.toTimeString().slice(0, 5);

    const data = {
      UserId: user?.userId,
      ProductId: IdOfProduct,
      TheDate: formattedDate,
      TheTime: formattedTime,
    };
    axios
      .post(`${MyDomain}Recently/CreateRecently`, data)
      .then((response) => {})
      .catch((error) => {});
  };

  const handleDivClick = () => {
    history.push({
      pathname:
        CatCall === "Perfume"
          ? `/allcategories/1000`
          : CatCall === "Womens bags"
          ? `/allcategories/7005`
          : CatCall === "Womens wallet"
          ? `/allcategories/7006`
          : CatCall === "Set bags"
          ? `/allcategories/7007`
          : CatCall === "Womens watches"
          ? `/allcategories/7008`
          : `/allcategories/7000`,
    });
    scrollToTop2();
  };

  const scrollToTop2 = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const OpenMobileDrawerFunc = (productDropDowns1) => {
    const result = productDropDowns1.find((item) => item.id === item.productId);
    setImageChoosed(result.image);
    setMobileDrawerOpen(true);
    setProductChoosed(productDropDowns1);
    setOBJOfProductChoosed(result);
  };

  const handleClose2 = () => {
    setMobileDrawerOpen(false);
    setProductChoosed([]);
    setProductChoosed2(0);
    setOBJOfProductChoosed({});
  };

  const CreateProduct3 = () => {
    if (!user) {
      setBuyNotLogin(true);
      return;
    }

    setLoadingClickBuyButton(true);
    const data = {
      UserId: user?.userId,
      IdOfProduct: OBJOfProductChoosed.id,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data)
      .then((response) => {
        setLoadingClickBuyButton(false);
        setCartAmount(response.data.userCart.length);
        handleClose2();
        handleOpenDialog();
      })
      .catch((err) => {
        setLoadingClickBuyButton(false);
        console.log(err);
      });
  };

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (MyWidth > 1024) {
      document.body.style.overflowX = "hidden";
      const slickList = wrapperRef.current?.querySelector(".slick-list");
      if (slickList) {
        slickList.style.overflow = "visible";
        slickList.style.clipPath = "inset(0px 0px -150px 0px)";
      }
    }
  }, [MyWidth]);

  const SectionProducts = AllData.filter(
    (item) => item.mainPageCallCatName === CatCall
  );

  // Group products by productId to handle different sizes
  const groupedProducts = SectionProducts.reduce((acc, product) => {
    const existingProduct = acc.find((p) => p.productId === product.productId);

    if (existingProduct) {
      if (!existingProduct.sizes) {
        existingProduct.sizes = [existingProduct.dropDown];
      }
      existingProduct.sizes.push(product.dropDown);
      if (!existingProduct.variants) {
        existingProduct.variants = [existingProduct];
      }
      existingProduct.variants.push(product);
    } else {
      acc.push({
        ...product,
        sizes: null,
        variants: null,
      });
    }

    return acc;
  }, []);

  const itemsPerView = MyWidth < 1024 ? 2 : MyWidth < 1440 ? 4 : 5;
  const maxIndex = Math.max(
    0,
    Math.ceil(groupedProducts.length / itemsPerView) - 1
  );

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
  };

  const getAvailableSizes = (product) => {
    if (product.sizes && product.sizes.length > 1) {
      return product.sizes;
    }
    if (product.dropDownOrDialog === 1 && product.dropDown) {
      return [product.dropDown];
    }
    return null;
  };

  const handleOpenDialog = () => {
    setMyOpen(true);
  };

  const handleCloseDialog = () => {
    setMyOpen(false);
  };

  const CloseModalBuyNotLogin = () => {
    setBuyNotLogin(false);
  };

  const ModalBuyNotLogin = () => {
    return (
      <BootstrapDialog
        onClose={CloseModalBuyNotLogin}
        aria-labelledby="customized-dialog-title"
        open={BuyNotLogin}
        fullWidth
        maxWidth={false}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <img
            src={CloseImg}
            alt="close"
            style={{
              minWidth: "30px",
              height: "30px",
              marginRight: 10,
              marginTop: 10,
              cursor: "pointer",
            }}
            onClick={() => setBuyNotLogin(false)}
          />
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          <div
            style={{
              width: "100%",
              height: "calc(50vh - 55px)",
              padding: 20,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a>{t("profile.Pleaseloginfirsttopurchasethisproduct")}</a>
            <button
              style={{
                marginTop: 40,
                backgroundColor: "#27272a",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                width: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: 50,
              }}
              onClick={() => {
                setBuyNotLogin(false);
                setOpenLoginPopOver(true);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <a style={{ fontSize: 14 }}>{t("profile.Ok")}</a>
            </button>
          </div>
        </div>
      </BootstrapDialog>
    );
  };

  const MyModal2 = () => {
    return (
      <BootstrapDialogMobile
        onClose={handleClose2}
        aria-labelledby="customized-dialog-title"
        open={MobileDrawerOpen}
        fullWidth
        maxWidth={false}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose2}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <div style={{ fontFamily: "Droid Arabic Kufi, sans-serif" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "35%",
                height: "calc(75vh - 55px)",
                paddingTop: "1%",
                paddingBottom: "1%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={ImageChoosed}
                style={{
                  width: "80%",
                }}
              />
            </div>
            <div
              style={{
                width: "55%",
                height: "calc(75vh - 55px)",
                display: "flex",
                paddingTop: "1%",
                paddingBottom: "1%",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex" }}>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: 18,
                    paddingBottom: 40,
                  }}
                >
                  {ProductChoosed[0]?.name}
                </p>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    MyWidth <= 1024 ? "repeat(1, 1fr)" : "repeat(3, 1fr)",
                  height: "80%",
                }}
              >
                {ProductChoosed.map((product, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      width: "100%",
                      height: 100,
                      paddingTop: "5%",
                      paddingLeft: "5%",
                      border:
                        ProductChoosed2 === index
                          ? "1px solid black"
                          : hoveredIndex === index
                          ? "1px solid black"
                          : "1px solid #ccc",
                      cursor: "pointer",
                      flexDirection: "column",
                    }}
                    onClick={() => {
                      setImageChoosed(product.image);
                      setProductChoosed2(index);
                      setOBJOfProductChoosed(ProductChoosed[index]);
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <img
                      src={product.image}
                      style={{
                        width: 30,
                        height: 30,
                      }}
                    />
                    <p style={{ margin: 0 }}>{product.dropDown}</p>
                  </div>
                ))}
              </div>
              <div
                style={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {/* Discount Badge */}
                  <p style={{ margin: 0 }}>
                    <a style={{ fontSize: 15 }}>
                      {OBJOfProductChoosed.discount === 0 ? (
                        <></>
                      ) : (
                        <>
                          {OBJOfProductChoosed.theDeal === 1 ? (
                            <>
                              <a
                                style={{
                                  backgroundColor: "#6b21a8",
                                  color: "white",
                                  margin: 0,
                                  marginBottom: 5,
                                  paddingLeft: 5,
                                  paddingRight: 5,
                                  fontSize: 15,
                                }}
                              >
                                -{OBJOfProductChoosed.discount}%
                              </a>
                              <a style={{ fontSize: 12 }}>&nbsp;</a>
                            </>
                          ) : (
                            <>
                              <a
                                style={{
                                  backgroundColor: "#6b21a8",
                                  color: "white",
                                  fontSize: 12,
                                  paddingLeft: 5,
                                  paddingRight: 5,
                                }}
                              >
                                Buy 2 pcs to get -{OBJOfProductChoosed.discount}
                                % off every {OBJOfProductChoosed.theDeal}
                                {OBJOfProductChoosed.theDeal === 2
                                  ? "nd"
                                  : "th"}{" "}
                                item
                              </a>
                            </>
                          )}
                        </>
                      )}
                    </a>
                  </p>
                  &nbsp; &nbsp;
                  {/* Discounted Price (Red) */}
                  {OBJOfProductChoosed.discount !== 0 &&
                    OBJOfProductChoosed.theDeal === 1 && (
                      <p
                        style={{
                          margin: 0,
                          color: "red",
                          fontSize: 15,
                        }}
                      >
                        ₪
                        {(
                          OBJOfProductChoosed.price -
                          (OBJOfProductChoosed.price *
                            OBJOfProductChoosed.discount) /
                            100
                        ).toFixed(2)}
                        &nbsp; &nbsp;
                      </p>
                    )}
                  {/* Original Price or PriceInsteadOf */}
                  {OBJOfProductChoosed.priceInsteadOf === 0 ? (
                    <a
                      style={{
                        textDecoration:
                          OBJOfProductChoosed.discount === 0 ||
                          OBJOfProductChoosed.theDeal === 2
                            ? "none"
                            : "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{OBJOfProductChoosed.price}
                    </a>
                  ) : (
                    <>
                      <a
                        style={{
                          margin: 0,
                          color: "red",
                          textDecoration: "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{OBJOfProductChoosed.price}
                      </a>
                      &nbsp;&nbsp;
                      <a
                        style={{
                          textDecoration:
                            OBJOfProductChoosed.discount === 0 ||
                            OBJOfProductChoosed.theDeal === 2
                              ? "none"
                              : "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{OBJOfProductChoosed.priceInsteadOf}
                      </a>
                    </>
                  )}
                  &nbsp; &nbsp;
                  <button
                    style={{
                      backgroundColor: "#27272a",
                      color: "#fff",
                      border: "none",
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "16px",
                      width: 200,
                      height: 50,
                    }}
                    onClick={CreateProduct3}
                  >
                    {LoadingClickBuyButton ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Lottie
                          style={{ height: 30, width: 30 }}
                          animationData={LottifileLoading}
                        />
                      </div>
                    ) : (
                      t("profile.Buy")
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BootstrapDialogMobile>
    );
  };

  const visibleProducts = groupedProducts.slice(
    currentIndex * itemsPerView,
    (currentIndex + 1) * itemsPerView
  );

  const TitleOfTheComp = (CatCall) => {
    switch (CatCall) {
      case "Perfume":
        return <a>{t("categories.Perfumes")}</a>;
      case "Makeup":
        return <a>{t("categories.Makeup")}</a>;
      case "Hair":
        return <a>{t("categories.Hair")}</a>;
      case "Face":
        return <a>{t("categories.Face")}</a>;
      case "BathandBody":
        return <a>{t("categories.BathandBody")}</a>;
      case "ForMen":
        return <a>{t("categories.ForMen")}</a>;
      case "Accessories":
        return <a>{t("categories.Accessories")}</a>;
      case "HealthandCare":
        return <a>{t("categories.HealthandCare")}</a>;
      case "Gifts":
        return <a>{t("categories.Gifts")}</a>;
      case "Womens bags":
        return <a>{t("categories.WomensBags")}</a>;
      case "Womens wallet":
        return <a>{t("categories.womenswallet")}</a>;
      case "Set bags":
        return <a>{t("categories.Setbags")}</a>;
      case "Womens watches":
        return <a>{t("categories.Womenswatches")}</a>;
      default:
        return <a>Unknown status</a>;
    }
  };

  return (
    <div
      ref={wrapperRef}
      style={{
        position: "relative",
        paddingTop: "100px",
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      {ModalBuyNotLogin()}
      {MyModal2()}

      <AllCategoriesCartDialog
        MyOpen={MyOpen}
        onClose={handleCloseDialog}
        handleDivClick2={handleDivClick2}
        MyRecommendedProductsData={{ products: [] }}
      />

      <div
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
          paddingBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p style={{ fontWeight: "500", fontSize: 25 }}>{"         "}</p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontWeight: "500",
              fontSize: 25,
              fontFamily: "Droid Arabic Kufi, sans-serif",
            }}
          >
            {TitleOfTheComp(CatCall)}
          </p>
        </div>
        <div style={{ alignItems: "center", display: "flex" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingRight: 30,
              cursor: currentIndex === 0 ? "default" : "pointer",
            }}
            onClick={currentIndex === 0 ? null : handlePrev}
          >
            <img
              src={arrowleft}
              alt="Previous"
              style={{
                width: 35,
                height: 35,
                opacity: currentIndex === 0 ? 0.3 : 1,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: currentIndex === maxIndex ? "default" : "pointer",
            }}
            onClick={currentIndex === maxIndex ? null : handleNext}
          >
            <img
              src={arrowright}
              alt="Next"
              style={{
                width: 35,
                height: 35,
                opacity: currentIndex === maxIndex ? 0.3 : 1,
              }}
            />
          </div>
        </div>
      </div>

      {/* Show All Button */}
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          padding: "8px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
            border: "1px solid #d4d4d8",
            borderRadius: "8px",
            padding: "16px 24px",
            margin: "8px",
            width: MyWidth <= 1024 ? "100%" : "50%",
            maxWidth: "600px",
            cursor: "pointer",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
          }}
          onClick={() => {
            handleDivClick();
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #f8f9fa 0%, #e4e4e7 100%)";
            e.currentTarget.style.borderColor = "#a1a1aa";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.08)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)";
            e.currentTarget.style.borderColor = "#d4d4d8";
            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <a
            style={{
              margin: 0,
              fontSize: "15px",
              fontWeight: "500",
              color: "#27272a",
              userSelect: "none",
              lineHeight: "1.5",
            }}
          >
            {t("categories.ShowallPerfumes")} {TitleOfTheComp(CatCall)}
          </a>
          <img
            src={arrowright}
            alt="Arrow"
            style={{
              width: "20px",
              height: "20px",
              margin: 0,
              transition: "transform 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateX(4px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateX(0)";
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          direction: i18n.resolvedLanguage === "en" ? "ltr" : "rtl",
          gap: "20px",
        }}
      >
        {visibleProducts.map((product) => {
          const availableSizes = getAvailableSizes(product);

          return (
            <ProductCard
              key={product.id}
              product={product}
              availableSizes={availableSizes}
              user={user}
              MyWidth={MyWidth}
              WishList={WishList}
              setWishList={setWishList}
              CartAmount={CartAmount}
              setCartAmount={setCartAmount}
              setBuyNotLogin={setBuyNotLogin}
              handleOpenDialog={handleOpenDialog}
              setOpenLoginPopOver={setOpenLoginPopOver}
              handleDivClick2={handleDivClick2}
              OpenMobileDrawerFunc={OpenMobileDrawerFunc}
              AllData={AllData}
              t={t}
              i18n={i18n}
            />
          );
        })}
      </div>
    </div>
  );
}

function ProductCard({
  product,
  availableSizes,
  user,
  MyWidth,
  WishList,
  setWishList,
  CartAmount,
  setCartAmount,
  setBuyNotLogin,
  handleOpenDialog,
  setOpenLoginPopOver,
  handleDivClick2,
  OpenMobileDrawerFunc,
  AllData,
  t,
  i18n,
}) {
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isHeartHovered, setIsHeartHovered] = useState(false);
  const [LoadingClickBuyButton, setLoadingClickBuyButton] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [price, setPrice] = useState(product.price);
  const [priceInsteadOf, setPriceInsteadOf] = useState(product.priceInsteadOf);
  const [discount, setDiscount] = useState(
    product.discount === 0
      ? null
      : product.price - (product.price * product.discount) / 100
  );
  const [thedeal, setThedeal] = useState(product.theDeal);
  const [theDiscount, setTheDiscount] = useState(product.discount);
  const [IdOfProduct, setIdOfProduct] = useState(product.id);
  const [hoverPrice, setHoverPrice] = useState(null);
  const [hoverPriceInsteadOf, setHoverPriceInsteadOf] = useState(null);
  const [hoverDiscount, setHoverDiscount] = useState(null);
  const [hoverThedeal, setHoverThedeal] = useState(null);
  const [hoverTheDiscount, sethoverTheDiscount] = useState(null);

  const dropdownRef = useRef(null);

  const averageRating =
    product.numberUsersRating > 0
      ? Math.floor(product.rating / product.numberUsersRating)
      : 0;
  const [ReviewsProduct] = useState(averageRating);
  const [NumberUsersReview] = useState(product.numberUsersRating || 0);

  const newArray1 = AllData.filter(
    (item) => item.productId === product.productId
  );
  const productDropDowns1 = newArray1.map((item) => item);

  useEffect(() => {
    if (availableSizes && availableSizes.length > 0) {
      setSelectedOption(availableSizes[0]);
    }
  }, [availableSizes]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const CreateProduct = () => {
    if (!user) {
      setBuyNotLogin(true);
      return;
    }

    setLoadingClickBuyButton(true);
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data)
      .then((response) => {
        setLoadingClickBuyButton(false);
        setCartAmount(response.data.userCart.length);
        handleOpenDialog();
      })
      .catch((err) => {
        setLoadingClickBuyButton(false);
        console.log(err);
      });
  };

  const AddProductToWishList = async () => {
    const data = {
      ProductId: IdOfProduct,
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}WishList/AddProductToWishList`, data)
      .then((response) => {
        setWishList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const DeleteFromWishList = async () => {
    axios
      .delete(`${MyDomain}WishList/DeleteFromWishList`, {
        data: { ProductId: IdOfProduct, UserId: user?.userId },
      })
      .then((response) => {
        setWishList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const toggleWishlist = async () => {
    if (!user) {
      setOpenLoginPopOver(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const productExists = WishList.some(
      (item) => item.productId === IdOfProduct
    );
    if (productExists) {
      await DeleteFromWishList();
    } else {
      await AddProductToWishList();
    }
  };

  return (
    <div
      onMouseEnter={() => {
        if (MyWidth > 1024) {
          setIsDivHovered(true);
        }
      }}
      onMouseLeave={() => {
        if (MyWidth > 1024) {
          setIsDivHovered(false);
        }
      }}
      style={{
        width: MyWidth < 1024 ? "49%" : MyWidth < 1440 ? "24.5%" : "19.5%",
        height: MyWidth <= 1024 ? 450 : 650,
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          backgroundColor: "#fafafa",
        }}
      >
        <div
          style={{
            margin: 0,
            backgroundColor: "#27272a",
            transition: "color 0.3s ease",
            cursor: "pointer",
            height: MyWidth <= 1024 ? "50%" : "100%",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "10px",
              color: "white",
              padding: product.deals !== "" ? 5 : 0,
              paddingLeft: product.deals !== "" ? 10 : 0,
              paddingRight: product.deals !== "" ? 10 : 0,
              fontWeight: "bold",
            }}
          >
            {product.deals === "ORIGINAL" && t("profile.original")}
            {product.deals === "MASTER" && t("profile.master")}
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", padding: 6, borderRadius: 50 }}>
            <FaHeart
              onMouseEnter={() => setIsHeartHovered(true)}
              onMouseLeave={() => setIsHeartHovered(false)}
              onClick={toggleWishlist}
              style={{
                fontSize: "18px",
                color:
                  MyWidth <= 1024
                    ? WishList.some((item) => item.productId === IdOfProduct)
                      ? "#4f46e5"
                      : "#ccc"
                    : isHeartHovered
                    ? "#4f46e5"
                    : WishList.some((item) => item.productId === IdOfProduct)
                    ? "#4f46e5"
                    : "#ccc",
                transition: "color 0.3s ease",
                opacity:
                  MyWidth <= 1024
                    ? 1
                    : isDivHovered ||
                      isHeartHovered ||
                      WishList.some((item) => item.productId === IdOfProduct)
                    ? 1
                    : 0,
                cursor: "pointer",
              }}
            />
          </div>
          {MyWidth <= 1024 && (
            <div
              style={{
                display: "flex",
                padding: 6,
                borderRadius: 50,
                cursor: "pointer",
              }}
              onClick={() => {
                OpenMobileDrawerFunc(productDropDowns1);
              }}
            >
              <img
                src={shoppingbag}
                alt="bag"
                style={{ maxHeight: 20, maxWidth: 20, objectFit: "contain" }}
              />
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#fafafa",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          flexDirection: "column",
        }}
        onClick={() => {
          handleDivClick2("product", product.id);
        }}
      >
        <img
          src={product.image}
          alt={product.name}
          style={{
            height: MyWidth <= 1024 ? 200 : 300,
            width: "100%",
            objectFit: "contain",
          }}
        />
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-start",
            height: "30px",
            alignItems: "center",
          }}
        >
          {product.newsCodeCat !== 0 && (
            <a
              style={{
                fontSize: 12,
                backgroundColor: "#6b21a8",
                padding: 3,
                margin: 5,
                color: "white",
                paddingLeft: 8,
                paddingRight: 8,
              }}
            >
              NEW
            </a>
          )}
        </div>
      </div>

      <p
        style={{ fontSize: 18, marginBottom: 1, cursor: "pointer" }}
        onClick={() => {
          handleDivClick2("product", product.id);
        }}
      >
        {product.name}
      </p>
      <p style={{ fontSize: 15, opacity: 0.5 }}>{product.productType}</p>

      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <Rating
          name="read-only"
          value={ReviewsProduct}
          readOnly
          sx={{
            fontSize: "0.75rem",
            "& .MuiRating-icon": {
              color: "black",
              paddingRight: "0 2px",
              opacity: NumberUsersReview === 0 ? 0.2 : 1,
            },
            "& .MuiRating-iconFilled": { color: "black" },
            "& .MuiRating-iconHover": { color: "black" },
          }}
        />
        {NumberUsersReview !== 0 && (
          <a style={{ fontSize: 14, opacity: 0.5 }}>
            &nbsp;{NumberUsersReview}
          </a>
        )}
      </div>

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          height: 50,
        }}
      >
        <div style={{ flexDirection: "row", display: "flex" }}>
          <p>
            {hoverDiscount !== null &&
              hoverDiscount?.toFixed(2) !== hoverPrice?.toFixed(2) &&
              hoverThedeal === 1 && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <a style={{ color: "red", fontSize: 15 }}>
                    {hoverTheDiscount !== 0 && "₪"}
                    {hoverDiscount?.toFixed(2)}
                    {hoverTheDiscount !== 0 && "\u00A0\u00A0"}
                  </a>
                </div>
              )}
            {hoverDiscount === null &&
              discount?.toFixed(2) !== price?.toFixed(2) &&
              thedeal === 1 && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <a style={{ color: "red", fontSize: 15 }}>
                    {theDiscount !== 0 && "₪"}
                    {discount?.toFixed(2)}
                    {theDiscount !== 0 && "\u00A0\u00A0"}
                  </a>
                </div>
              )}
          </p>
          <p>
            {hoverPrice !== null ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {hoverPriceInsteadOf === 0 ? (
                  <a
                    style={{
                      textDecoration:
                        hoverTheDiscount === 0 || hoverThedeal === 2
                          ? "none"
                          : "line-through",
                      fontSize: 15,
                    }}
                  >
                    ₪{hoverPrice}
                  </a>
                ) : (
                  <>
                    <a
                      style={{
                        margin: 0,
                        color: "red",
                        textDecoration: "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{hoverPrice}
                    </a>
                    &nbsp;&nbsp;
                    <a
                      style={{
                        textDecoration:
                          hoverTheDiscount === 0 || hoverThedeal === 2
                            ? "none"
                            : "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{hoverPriceInsteadOf}
                    </a>
                  </>
                )}
              </div>
            ) : (
              <>
                {priceInsteadOf === 0 ? (
                  <a
                    style={{
                      textDecoration:
                        theDiscount === 0 || thedeal === 2
                          ? "none"
                          : "line-through",
                      fontSize: 15,
                    }}
                  >
                    ₪{price}
                  </a>
                ) : (
                  <>
                    <a
                      style={{
                        margin: 0,
                        color: "red",
                        textDecoration: "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{price}
                    </a>
                    &nbsp;&nbsp;
                    <a
                      style={{
                        textDecoration:
                          theDiscount === 0 || thedeal === 2
                            ? "none"
                            : "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{priceInsteadOf}
                    </a>
                  </>
                )}
              </>
            )}
          </p>
        </div>
        <div>
          {hoverTheDiscount !== null &&
            hoverTheDiscount !== 0 &&
            hoverThedeal === 1 && (
              <a
                style={{
                  backgroundColor: "#6b21a8",
                  color: "white",
                  fontSize: 12,
                  paddingLeft: 5,
                  paddingRight: 5,
                }}
              >
                -{hoverTheDiscount}%
              </a>
            )}
          {hoverTheDiscount === null && theDiscount !== 0 && thedeal === 1 && (
            <a
              style={{
                backgroundColor: "#6b21a8",
                color: "white",
                paddingLeft: 5,
                paddingRight: 5,
                fontSize: 15,
              }}
            >
              -{theDiscount}%
            </a>
          )}
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#fff",
          padding: "1px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transition: "transform 0.3s ease, opacity 0.3s ease",
          transform: isDivHovered ? "translateY(0)" : "translateY(-100%)",
          opacity: isDivHovered ? 1 : 0,
          height: "50px",
          flexDirection: "column",
        }}
      >
        <div style={{ width: "100%", paddingBottom: 5, paddingTop: 50 }}>
          <div
            ref={dropdownRef}
            style={{ position: "relative", display: "flex" }}
          >
            <button
              onClick={toggleDropdown}
              style={{
                padding: "10px 20px",
                backgroundColor: "white",
                color: "white",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent:
                  availableSizes && availableSizes.length > 1
                    ? "space-between"
                    : "center",
                width: "100%",
                border:
                  availableSizes && availableSizes.length > 1
                    ? "1px solid #e4e4e7"
                    : "1px solid #18181b",
              }}
            >
              <p style={{ color: "black", margin: 0 }}>{selectedOption}</p>
              {availableSizes && availableSizes.length > 1 && (
                <span
                  style={{
                    marginLeft: "10px",
                    display: "inline-block",
                    transition: "transform 0.3s ease",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    color: "black",
                  }}
                >
                  <img
                    src={ArrowDown}
                    alt="dropdown"
                    style={{ width: 12, height: 12 }}
                  />
                </span>
              )}
            </button>
            {availableSizes && availableSizes.length > 1 && (
              <ul
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "0",
                  backgroundColor: "white",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  padding: "0",
                  margin: "0",
                  listStyleType: "none",
                  width: "100%",
                  maxHeight: isOpen ? "150px" : "0",
                  overflowY: "auto",
                  opacity: isOpen ? "1" : "0",
                  transition: "all 0.3s ease",
                  zIndex: 1000,
                }}
              >
                {product.variants &&
                  product.variants.map((variant) => (
                    <li
                      key={variant.id}
                      style={{ padding: "10px 20px", cursor: "pointer" }}
                      onClick={() => {
                        handleOptionClick(variant.dropDown);
                        setTheDiscount(variant.discount);
                        setPrice(variant.price);
                        setPriceInsteadOf(variant.priceInsteadOf);
                        setThedeal(variant.theDeal);
                        setDiscount(
                          variant.price -
                            (variant.price * variant.discount) / 100
                        );
                        setIdOfProduct(variant.id);
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f1f1f1";
                        sethoverTheDiscount(variant.discount);
                        setHoverPrice(variant.price);
                        setHoverPriceInsteadOf(variant.priceInsteadOf);
                        setHoverThedeal(variant.theDeal);
                        setHoverDiscount(
                          variant.price -
                            (variant.price * variant.discount) / 100
                        );
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white";
                        sethoverTheDiscount(null);
                        setHoverPrice(null);
                        setHoverPriceInsteadOf(null);
                        setHoverThedeal(null);
                        setHoverDiscount(null);
                      }}
                    >
                      {variant.dropDown}
                    </li>
                  ))}
              </ul>
            )}
          </div>
        </div>
        <button
          style={{
            backgroundColor: "#27272a",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            cursor: "pointer",
            fontSize: "16px",
            width: "100%",
          }}
          onClick={CreateProduct}
        >
          {LoadingClickBuyButton ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Lottie
                style={{ height: 30, width: 30 }}
                animationData={LottifileLoading}
              />
            </div>
          ) : (
            t("profile.Buy")
          )}
        </button>
      </div>
    </div>
  );
}
